import React, { useState } from "react";

function GetStarted({ data }) {
  const [selectedButton, setSelectedButton] = useState(0);
  const [videoLink, setVideoLink] = useState(data?.getStarted[0]?.videoLink || "");

  return (
    <div className="get-started">
      <div className="inward-container container">
        <div data-aos="fade-up" data-aos-delay="150">
          <h1 className="heading mb-5">Get started</h1>
        </div>
        <div className="toggle-slider-container">
          <div
            className="toggle-slider"
            style={{
              transform: `translateX(${selectedButton === 0 ? "0%" : "100%"})`,
            }}
          />
          {
            data?.getStarted.map((item, index) => (
              <div
                className={`sliding-button`}
                onClick={() => {
                  setSelectedButton(index);
                  setVideoLink(item?.videoLink);
                }}
              >
                {item?.title}
              </div>
            ))
          }
          {/* <div
            className={`sliding-button`}
            onClick={() => setSelectedButton(1)}
          >
            New-to-alrajhi bank Malaysia customers
          </div>
          <div
            className={`sliding-button`}
            onClick={() => setSelectedButton(2)}
          >
            alrajhi@24seven users
          </div> */}
        </div>
        <iframe
          data-aos="fade-up"
          data-aos-delay="150"
          className="video-player"
          src={videoLink}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  );
}

export default GetStarted;
